<template>
  <transition appear name="slide-up" mode="in-out">
    <div v-if="visible" class="cookie-consent" @touchmove="handleTouchMove">
      <v-row justify="center">
        <span class="fonts-black pl-4 pr-4 pt-2">
          This website uses cookies to ensure you get the best experience on our website.
          If you continue to use this site, we assume you agree to our
          <v-btn text plain :ripple="false" elevation="0" style="color:black!important;"
            class="text-none nomenu-btn-page pb-1 pl-0 ml-0 pr-0 mr-0" @click="handleClickMenu('Privacy')">
            Privacy policy
          </v-btn>
          if you do not agree, please leave immediately.
        </span>
      </v-row>
      <v-row justify="center" class="pt-4 pb-4">
        <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 150px; height: 40px;"
          @click="acceptCookies">
          Accept
        </v-btn>
      </v-row>
    </div>
  </transition>
</template>

<script>
export default {

  name: 'CookieConsent',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    checkCookieConsent() {
      const consent = localStorage.getItem('cookie-consent-muzible');
      if (!consent) {
        this.visible = true;
      }
    },
    acceptCookies() {
      localStorage.setItem('cookie-consent-muzible', 'accepted');
      this.visible = false;
    },
    handleClickMenu(link) {
      if (link === 'Privacy') {
        window.open('https://muzible.com/privacy', '_blank');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },
    handleTouchMove(event) {
      event.preventDefault();
    },

  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  max-width: 100vw;
  min-height: 100px;
  background-color: white;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-top: 1px solid black;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.5s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}

.menu-btn-icon-border {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: bold !important;
  font-size: 20px !important;
  border: 1px solid black !important;
  box-shadow: none !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  transition: none !important;
  background-color: black !important;
}

.menu-btn-icon-border:hover {
  color: black !important;
  border: 1px solid black !important;
  background-color: white !important;
  transition: none !important;
}

.menu-btn-icon-border:hover .v-icon {
  color: black !important;
  transition: none !important;
}

.menu-btn-icon-border:before {
  display: none !important;
}


.fonts-black {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  color: black;

  @media (min-width: 600px) {
    font-size: 18px !important;
  }

  @media (min-width: 1280px) {
    font-size: 18px !important;
  }
}

.nomenu-btn-page {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 16px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}


.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 27px;
  width: 100%;
  /* Spread the line over the text and icon */
  height: 1px;
  /* Line thickness */
  background-color: black;
  /* Color of the underline */
  opacity: 1;
  /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3;
  /* Show the underline when hovering */
}

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}
</style>